import type { EventParameter } from "./eventParameter";
import type { EventType } from "./eventType";

let nextId = 1;

export class Event {
	readonly id: number;
	readonly type: EventType;
	private parameters: Map<EventParameter, string> = new Map();

	constructor(type: EventType) {
		this.id = nextId++;
		this.type = type;
	}

	setParameter(key: EventParameter, value: string): void {
		this.parameters.set(key, value);
	}

	getParameter(key: EventParameter): string | undefined {
		return this.parameters.get(key);
	}
}
